import React, { useEffect } from "react";
import Slider from "react-slick";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import { fetchAllUsers } from "../redux/slices/connectionSlice";

// ==========================
// API BASE URL
// ==========================
const API_URL = (
  process.env.REACT_APP_API_URL ||
  "https://api.bsangam.com"
).replace(/\/$/, "");

// ==========================
// UPLOAD URL HELPER
// ==========================
const getUploadUrl = (
  pathValue?: string | null,
  fallbackFolder = ""
) => {
  if (
    !pathValue ||
    String(pathValue).trim() === ""
  ) {
    return "";
  }

  const imagePath =
    String(pathValue).trim();

  // Already full URL
  if (
    imagePath.startsWith("http://") ||
    imagePath.startsWith("https://")
  ) {
    return encodeURI(imagePath);
  }

  // /uploads/filename.jpg
  if (
    imagePath.startsWith("/uploads/")
  ) {
    return encodeURI(
      `${API_URL}${imagePath}`
    );
  }

  // uploads/filename.jpg
  if (
    imagePath.startsWith("uploads/")
  ) {
    return encodeURI(
      `${API_URL}/${imagePath}`
    );
  }

  // Example:
  // profile_photo = filename.jpg
  // fallbackFolder = /uploads/profile-photos
  if (fallbackFolder) {
    return encodeURI(
      `${API_URL}${fallbackFolder}/${imagePath.replace(
        /^\/+/,
        ""
      )}`
    );
  }

  // /some/path/file.jpg
  if (
    imagePath.startsWith("/")
  ) {
    return encodeURI(
      `${API_URL}${imagePath}`
    );
  }

  // filename.jpg
  return encodeURI(
    `${API_URL}/uploads/${imagePath}`
  );
};

// ==========================
// PROFILE PHOTO
// ==========================
const getProfilePhoto = (
  photo?: string | null
) => {
  return getUploadUrl(
    photo,
    "/uploads/profile-photos"
  );
};

// ==========================
// CLIENT LOGO
// ==========================
const getClientLogo = (
  logo?: string | null
) => {
  return getUploadUrl(logo);
};

// ==========================
// USER INITIAL
// ==========================
const getInitial = (
  name?: string
) => {
  if (
    !name ||
    String(name).trim() === ""
  ) {
    return "U";
  }

  return String(name)
    .trim()
    .charAt(0)
    .toUpperCase();
};

const Memberslider: React.FC = () => {
  const dispatch =
    useDispatch<any>();

  const navigate =
    useNavigate();

  // ==========================
  // LOCAL STORAGE DATA
  // ==========================
  const user = JSON.parse(
    localStorage.getItem("user") ||
      "{}"
  );

  const selectedClient =
    JSON.parse(
      localStorage.getItem(
        "selectedClient"
      ) || "{}"
    );

  const loggedClient =
    JSON.parse(
      localStorage.getItem(
        "client"
      ) || "{}"
    );

  // ==========================
  // USER ID
  // ==========================
  const userId =
    user?.user_id ||
    selectedClient?.user_id ||
    loggedClient?.user_id ||
    null;

  // ==========================
  // REDUX
  // ==========================
  const {
    users = [],
    loading,
  } = useSelector(
    (state: any) =>
      state.connections
  );

  // ==========================
  // FETCH USERS
  // ==========================
  useEffect(() => {
    if (!userId) {
      return;
    }

    dispatch(
      fetchAllUsers({
        user_id: userId,
        search: "",
        limit: 12,
        offset: 0,
      })
    );
  }, [
    dispatch,
    userId,
  ]);

  // ==========================
  // SLIDER SETTINGS
  // ==========================
  const settings = {
    arrows: false,
    dots: false,

    infinite:
      users.length > 4,

    speed: 400,

    slidesToShow: 1,
    slidesToScroll: 1,

    variableWidth: true,
    swipeToSlide: true,
  };

  // ==========================
  // OPEN USERS PAGE
  // ==========================
  const handleUserProfileClick =
    () => {
      navigate("/users");
    };

  // ==========================
  // LOADING
  // ==========================
  if (loading) {
    return (
      <div
        style={{
          fontSize: "12px",
          color: "#64748b",
          padding: "12px",
        }}
      >
        Loading users...
      </div>
    );
  }

  // ==========================
  // EMPTY
  // ==========================
  if (
    !Array.isArray(users) ||
    users.length === 0
  ) {
    return null;
  }

  return (
    <Slider {...settings}>
      {users.map(
        (
          item: any,
          index: number
        ) => {
          // ==========================
          // PROFILE PHOTO
          // ==========================
          const profilePhoto =
            getProfilePhoto(
              item?.profile_photo ||
                item?.contact_photo ||
                item?.photo
            );

          // ==========================
          // CLIENT LOGO
          // ==========================
          const clientLogo =
            getClientLogo(
              item?.logo_image ||
                item?.client_logo
            );

          // ==========================
          // NAME
          // ==========================
          const displayName =
            item?.user_fullname ||
            item?.contact_name ||
            item?.full_name ||
            item?.name ||
            "Unknown User";

          // ==========================
          // DESIGNATION
          // ==========================
          const designation =
            item?.designation_name ||
            item?.job_title ||
            item?.profession ||
            item?.contact_profession ||
            "Member";

          // ==========================
          // COMMUNITY
          // ==========================
          const community =
            item?.client_name ||
            item?.club_name ||
            item?.company_name ||
            item?.business_name ||
            "Bharat Sangam";

          return (
            <div
              key={
                item?.user_id ||
                item?.contact_id ||
                index
              }
              style={{
                width: "178px",
                padding: "0 6px",
              }}
            >
              <div
                style={{
                  width: "166px",
                  background:
                    "#ffffff",

                  border:
                    "1px solid #edf1f7",

                  borderRadius:
                    "18px",

                  overflow:
                    "hidden",

                  boxShadow:
                    "0 8px 22px rgba(15, 23, 42, 0.04)",

                  transition:
                    "all 0.2s ease",
                }}
              >
                {/* ==========================
                    TOP COVER
                ========================== */}
                <div
                  style={{
                    height: "50px",

                    background:
                      "linear-gradient(135deg, #eaf3ff, #f8fafc)",
                  }}
                />

                <div
                  style={{
                    padding:
                      "0 12px 14px",

                    textAlign:
                      "center",
                  }}
                >
                  {/* ==========================
                      PROFILE IMAGE
                  ========================== */}
                  <figure
                    onClick={
                      handleUserProfileClick
                    }
                    role="button"
                    tabIndex={0}
                    title="View users"
                    onKeyDown={(e) => {
                      if (
                        e.key ===
                          "Enter" ||
                        e.key === " "
                      ) {
                        handleUserProfileClick();
                      }
                    }}
                    style={{
                      width: "62px",
                      height: "62px",

                      margin:
                        "-31px auto 8px",

                      borderRadius:
                        "50%",

                      border:
                        "4px solid #ffffff",

                      background:
                        "#eef4ff",

                      overflow:
                        "hidden",

                      boxShadow:
                        "0 5px 14px rgba(15, 23, 42, 0.1)",

                      cursor:
                        "pointer",
                    }}
                  >
                    {profilePhoto ? (
                      <img
                        src={
                          profilePhoto
                        }
                        alt={
                          displayName
                        }
                        onError={(
                          e
                        ) => {
                          e.currentTarget.style.display =
                            "none";
                        }}
                        style={{
                          width:
                            "100%",

                          height:
                            "100%",

                          objectFit:
                            "cover",
                        }}
                      />
                    ) : (
                      <div
                        style={{
                          width:
                            "100%",

                          height:
                            "100%",

                          background:
                            "#eef4ff",

                          color:
                            "#2563eb",

                          display:
                            "flex",

                          alignItems:
                            "center",

                          justifyContent:
                            "center",

                          fontSize:
                            "24px",

                          fontWeight:
                            600,
                        }}
                      >
                        {getInitial(
                          displayName
                        )}
                      </div>
                    )}
                  </figure>

                  {/* ==========================
                      USER NAME
                  ========================== */}
                  <h4
                    style={{
                      fontSize:
                        "13px",

                      fontWeight:
                        600,

                      color:
                        "#111827",

                      marginBottom:
                        "3px",

                      whiteSpace:
                        "nowrap",

                      overflow:
                        "hidden",

                      textOverflow:
                        "ellipsis",
                    }}
                  >
                    {displayName}
                  </h4>

                  {/* ==========================
                      DESIGNATION
                  ========================== */}
                  <p
                    style={{
                      fontSize:
                        "11px",

                      color:
                        "#64748b",

                      marginBottom:
                        "8px",

                      whiteSpace:
                        "nowrap",

                      overflow:
                        "hidden",

                      textOverflow:
                        "ellipsis",
                    }}
                  >
                    {designation}
                  </p>

                  {/* ==========================
                      COMMUNITY
                  ========================== */}
                  <div
                    style={{
                      minHeight:
                        "26px",

                      marginBottom:
                        "9px",

                      padding:
                        "4px 8px",

                      borderRadius:
                        "999px",

                      background:
                        "#f8fafc",

                      border:
                        "1px solid #edf2f7",

                      display:
                        "flex",

                      alignItems:
                        "center",

                      justifyContent:
                        "center",

                      gap: "5px",
                    }}
                  >
                    {clientLogo ? (
                      <img
                        src={
                          clientLogo
                        }
                        alt={
                          community
                        }
                        onError={(
                          e
                        ) => {
                          e.currentTarget.style.display =
                            "none";
                        }}
                        style={{
                          width:
                            "16px",

                          height:
                            "16px",

                          minWidth:
                            "16px",

                          borderRadius:
                            "5px",

                          objectFit:
                            "cover",
                        }}
                      />
                    ) : (
                      <span
                        style={{
                          width:
                            "16px",

                          height:
                            "16px",

                          minWidth:
                            "16px",

                          borderRadius:
                            "5px",

                          background:
                            "#eef4ff",

                          color:
                            "#2563eb",

                          display:
                            "flex",

                          alignItems:
                            "center",

                          justifyContent:
                            "center",

                          fontSize:
                            "9px",
                        }}
                      >
                        <i className="feather-users" />
                      </span>
                    )}

                    <p
                      style={{
                        margin: 0,

                        color:
                          "#475569",

                        fontSize:
                          "10px",

                        whiteSpace:
                          "nowrap",

                        overflow:
                          "hidden",

                        textOverflow:
                          "ellipsis",
                      }}
                    >
                      {community}
                    </p>
                  </div>

                  {/* ==========================
                      USER STATS
                  ========================== */}
                  <div
                    style={{
                      display:
                        "grid",

                      gridTemplateColumns:
                        "1fr 1fr",

                      gap: "6px",
                    }}
                  >
                    {/* MUTUALS */}
                    <div
                      style={{
                        background:
                          "#f8fafc",

                        borderRadius:
                          "12px",

                        padding:
                          "7px 4px",
                      }}
                    >
                      <h5
                        style={{
                          fontSize:
                            "12px",

                          fontWeight:
                            600,

                          color:
                            "#111827",

                          margin: 0,
                        }}
                      >
                        {item?.mutual_connections ||
                          0}
                      </h5>

                      <span
                        style={{
                          fontSize:
                            "9px",

                          color:
                            "#94a3b8",
                        }}
                      >
                        Mutuals
                      </span>
                    </div>

                    {/* CONNECTION STATUS */}
                    <div
                      style={{
                        background:
                          "#f8fafc",

                        borderRadius:
                          "12px",

                        padding:
                          "7px 4px",
                      }}
                    >
                      <h5
                        style={{
                          fontSize:
                            "12px",

                          fontWeight:
                            600,

                          color:
                            item?.connection_status ===
                            "pending"
                              ? "#c2410c"
                              : "#111827",

                          margin: 0,
                        }}
                      >
                        {item?.connection_status ===
                        "pending"
                          ? "Sent"
                          : "New"}
                      </h5>

                      <span
                        style={{
                          fontSize:
                            "9px",

                          color:
                            "#94a3b8",
                        }}
                      >
                        Status
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          );
        }
      )}
    </Slider>
  );
};

export default Memberslider;